import React, { memo, useEffect, useState } from 'react';
import { StyleSheet, Pressable, View } from 'react-native';
import BMText from '../Text/BMText';
import { BMPrimitives, useBMTheme } from '../../theme';
import DateCellAdditionalSlot from './DateCellAdditionalSlot';
function DateCellComponent(props) {
    const { activeTheme, BMComponents } = useBMTheme();
    const { date, onPress, isSelected, isHoliday, isDisabled, isStartDate, isEndDate, isInRange, isToday, todayLabel, selectedDateBackgroundColor = BMComponents.BMUiCalendarBgcolorSelected, selectedDateBorderColor = BMComponents.BMUiCalendarBordercolorSelected, selectedMidBackgroundColor = BMComponents.BMUiCalendarBgcolorSelected, customLocaleColor, topItem, topItemType, topLoading = false, topInk = 'BMStyleIconInkSecondary', bottomItem, bottomItemType, bottomLoading = false, bottomInk = 'BMStyleIconInkSecondary', } = props;
    const [styles, setStyles] = useState(() => calendarStyles(BMComponents));
    const isMarked = isSelected || isStartDate || isEndDate;
    useEffect(() => {
        setStyles(calendarStyles(BMComponents));
    }, [activeTheme]);
    const isTopSlotEmpty = !topItemType && !topItem && !topLoading;
    const _topSlot = isToday && isTopSlotEmpty
        ? {
            item: todayLabel,
            ink: 'BMStyleTextInkSecondary',
        }
        : {
            item: topItem,
            type: topItemType,
            loading: topLoading,
            ink: topInk,
        };
    return (<Pressable onPress={() => {
            if (isDisabled)
                return;
            onPress(date);
        }} style={[styles.baseContainer, isToday && styles.todayContainer]}>
      {isStartDate && !isEndDate && (<View style={[{ backgroundColor: selectedMidBackgroundColor }, styles.marker, styles.startDateMarker]}/>)}
      {isEndDate && !isStartDate && (<View style={[{ backgroundColor: selectedMidBackgroundColor }, styles.marker, styles.endDateMarker]}/>)}
      {isInRange && <View style={[{ backgroundColor: selectedMidBackgroundColor }, styles.marker]}/>}
      <DateCellAdditionalSlot {..._topSlot} position="top"/>
      <View style={[
            styles.dateContainer,
            isMarked && [
                {
                    backgroundColor: selectedDateBackgroundColor,
                    borderColor: selectedDateBorderColor,
                },
                styles.selectedContainer,
            ],
        ]}>
        <BMText variant={'uiHuge'} style={[
            styles.date,
            customLocaleColor ? { color: customLocaleColor } : null,
            isHoliday && styles.holiday,
            isDisabled && styles.disabled,
            (isInRange || isMarked) && !isDisabled && styles.selectedMid,
        ]}>
          {date.getDate()}
        </BMText>
      </View>
      <DateCellAdditionalSlot type={bottomItemType} item={bottomItem} loading={bottomLoading} ink={bottomInk}/>
    </Pressable>);
}
function EmptyDateCellComponent(props) {
    const { isInRange, selectedMidBackgroundColor } = props;
    const { BMComponents, activeTheme } = useBMTheme();
    const [styles, setStyles] = useState(() => calendarStyles(BMComponents));
    useEffect(() => {
        setStyles(() => calendarStyles(BMComponents));
    }, [activeTheme]);
    return (<View style={[
            styles.baseContainer,
            {
                flex: 1,
                alignItems: 'stretch',
                height: 70,
            },
        ]}>
      {isInRange && <View style={[{ backgroundColor: selectedMidBackgroundColor }, styles.marker]}/>}
    </View>);
}
const calendarStyles = (BMComponents) => StyleSheet.create({
    baseContainer: {
        alignItems: 'center',
        alignSelf: 'stretch',
        flex: 1,
        justifyContent: 'center',
        // Ack-ed by ui-dev,
        // For now, we are using a hardcoded height
        // since its not available in bm-size
        minHeight: 80,
        paddingVertical: BMPrimitives.BMSize.xs,
        backgroundColor: BMComponents.BMUiCalendarBgcolorPrimary,
        borderBottomWidth: BMPrimitives.BMBorder.width.thick,
        borderBottomColor: BMComponents.BMStyleLineBordercolorSubtle,
    },
    todayContainer: {
        backgroundColor: BMComponents.BMUiCalendarBgcolorToday,
        borderBottomColor: BMComponents.BMStyleLineBordercolorActive,
    },
    dateContainer: {
        alignSelf: 'stretch',
        height: 32,
        alignItems: 'center',
        justifyContent: 'center',
    },
    date: {
        color: BMComponents.BMUiCalendarInkDatePrimary,
        textAlign: 'center',
    },
    selectedContainer: {
        borderWidth: BMPrimitives.BMBorder.width.bold,
        borderRadius: BMPrimitives.BMBorder.radius.rounded,
    },
    selectedMid: {
        color: BMComponents.BMUiCalendarInkDateSelected,
    },
    holiday: {
        color: BMComponents.BMUiCalendarInkHoliday,
    },
    disabled: {
        color: BMComponents.BMUiCalendarInkDateDisabled,
    },
    todayMarker: {
        position: 'absolute',
        bottom: 0,
        width: '50%',
        height: 2,
        borderRadius: BMPrimitives.BMRadius.sm,
    },
    startDateMarker: {
        width: '50%',
        alignSelf: 'flex-end',
    },
    endDateMarker: {
        width: '50%',
        alignSelf: 'flex-start',
    },
    marker: {
        position: 'absolute',
        width: '100%',
        height: 24,
    },
    topInformation: {
        top: BMPrimitives.BMSize.xs,
    },
});
export const EmptyDateCell = memo(EmptyDateCellComponent);
export default memo(DateCellComponent);
